import "./CraftsmanshipSection.css";

import {
  FaPencilRuler,
  FaHands,
  FaCheckCircle,
  FaGift,
} from "react-icons/fa";

const process = [
  {
    icon: <FaPencilRuler />,
    title: "Design",
    description:
      "Every saree begins with carefully curated motifs inspired by India's rich cultural heritage.",
  },
  {
    icon: <FaHands />,
    title: "Hand Weaving",
    description:
      "Our skilled artisans weave every thread meticulously on traditional handlooms.",
  },
  {
    icon: <FaCheckCircle />,
    title: "Quality Check",
    description:
      "Each masterpiece undergoes multiple quality inspections before reaching you.",
  },
  {
    icon: <FaGift />,
    title: "Luxury Packaging",
    description:
      "Your saree is beautifully packed to preserve its elegance and ensure a premium experience.",
  },
];

const CraftsmanshipSection = () => {
  return (
    <section className="craftsmanship">

      <div className="container">

        <div className="craft-header">

          <span>OUR CRAFTSMANSHIP</span>

          <h2>
            Every Saree Is
            <br />
            Crafted With Love
          </h2>

          <p>
            From selecting the finest silk threads to the final
            finishing touches, every creation reflects unmatched
            craftsmanship and timeless elegance.
          </p>

        </div>

        <div className="craft-grid">

          {process.map((item, index) => (

            <div
              className="craft-card"
              key={index}
            >

              <div className="craft-number">
                0{index + 1}
              </div>

              <div className="craft-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default CraftsmanshipSection;